import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { Operation } from "@/types/permissions";
import { PropsWithChildren } from "react";

interface PermissionGuardProps {
  permission: Operation;
  resolveTo?: React.ReactNode;
}

export default function PermissionGuard({
  permission,
  resolveTo = null,
  children,
}: PropsWithChildren<PermissionGuardProps>) {
  const modulePermissions = useModulePermissions();

  if (!modulePermissions[permission]) {
    return resolveTo;
  }

  return children;
}
